import Moment from "moment";

export const filterType = {
  search: "textSearch",
  date: "date",
  number: "number",
  object: "object",
  bool: "bool"
}

export const getFiltros = (columnsTofilter, data) => {
  let filtros = [...columnsTofilter];
  if (data) {
    data.forEach((row) => {
      filtros = filtros.map((filterItem) => {
        const filtro = { ...filterItem };
        if (filtro.type) return filtro;
        if (filtro.values == null) filtro.values = [];

        const valueNotInFilter = filtro.values.findIndex(item => item.value === row[filtro.column]) === -1;
        if (valueNotInFilter) {
          if (filtro.customValues) {
            filtro.values = filtro.customValues;
          } else {
            const value = row[filtro.column];
            let text = row[filtro.column];
            if (value === true) text = "Si";
            if (value === false) text = "No";
            if (value == null) text = "S/D";
            filtro.values.push({ text, value });
          }
        }

        return filtro;
      });
    });
  }
  return filtros;
}

const groupFilters = (filters) => {
  let groupedFilter = [];
  filters.forEach((item => {

    let filterGroup = filters.filter(f => f.column === item.column);
    if (groupedFilter.findIndex(gf => gf.column === item.column) === -1) {
      groupedFilter.push({ type: item.type, column: item.column, values: filterGroup.map(item => item.value), filterValue: item.filterValue });
    }
  }));

  return groupedFilter;
}

export const filterData = (data, filter) => {
  let newData = data ? [...data] : [];


  let customFilters = filter;
  if (filter[1] === "and") {
    customFilters = [...filter[2]];
  }


  const filterGroup = groupFilters(customFilters);
  const filterSelect = filterGroup.filter(f => f.type !== filterType.search);

  const filterSearch = filterGroup.filter(f => f.type === filterType.search);

  newData = newData.filter(row =>
    filterSelect.every(filterItem => {

      if (!filterItem.values.length) {
        return true;
      }

      if (filterItem.type === filterType.number) {
        return filterItem.values.some(f => row[filterItem.column] >= f.value.from && row[filterItem.column] <= f.value.to);
      }
      if (filterItem.type === filterType.date) {


        const rowDate = Moment(new Date(row[filterItem.column]));


        return filterItem.values.some(f => rowDate.isSameOrAfter(f.value.from) && rowDate.isSameOrBefore(f.value.to));
      }

      if (filterItem.type === filterType.object) {

        return filterItem.values.some(f => f.value === row[filterItem.column][filterItem.filterValue])

      }

      if (filterItem.type === filterType.bool) {
        return filterItem.values.some(f => f.value === row[filterItem.column]);
      }

      return filterItem.values.some(f => f.value === row[filterItem.column] || (row[filterItem.column] !== undefined && row[filterItem.column] !== null && row[filterItem.column].indexOf(f.value) >= 0));

    })
  );


  if (filterSearch.length) {
    newData = newData.filter(row =>
      filterSearch.some(filter => {
        return filter.values.some(f => string1ContainsString2(row[filter.column] ? row[filter.column].toString() : null, f.value) !== -1);
      })
    )
  }

  return newData;
}

export const string1ContainsString2 = (string1, string2) => {
  if (!string1 || !string2) return -1;

  const str1 = string1.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  const str2 = string2.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");

  return str1.indexOf(str2);
}
